export var AdminPermission;
(function (AdminPermission) {
    AdminPermission["ManageJobs"] = "manage_jobs";
    AdminPermission["ManagePress"] = "manage_press";
    AdminPermission["ManageGuide"] = "manage_guide";
    AdminPermission["ManageUsers"] = "manage_users";
    AdminPermission["ManageClubs"] = "manage_clubs";
    AdminPermission["ManageEvents"] = "manage_events";
    AdminPermission["ManageParticipations"] = "manage_participations";
    AdminPermission["ManageAdmins"] = "manage_admins";
    AdminPermission["ManageAdminRoles"] = "manage_admin_roles";
    AdminPermission["ManageSettings"] = "manage_settings";
    AdminPermission["ManageStorage"] = "manage_storage";
    AdminPermission["ManageSupport"] = "manage_support";
    AdminPermission["ManageAudits"] = "manage_audits";
    AdminPermission["ManageReports"] = "manage_reports";
    AdminPermission["ManageFinisherPoints"] = "manage_finisher_points";
    AdminPermission["ManageTelescope"] = "manage_telescope";
    AdminPermission["ManageBlacklist"] = "manage_blacklist";
    AdminPermission["ManageAccounting"] = "manage_accounting";
    AdminPermission["ManageAnnouncements"] = "manage_announcements";
    AdminPermission["ManageSystem"] = "manage_system";
})(AdminPermission || (AdminPermission = {}));
//# sourceMappingURL=AdminPermission.js.map